import styled, { keyframes } from 'styled-components/macro';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

    &:disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    &:active {
      transform: scale(0.95);
      -webkit-tap-highlight-color: transparent;
    }

    &:focus {
      -webkit-tap-highlight-color: transparent;
    }
`;

const fadeToBlack = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 200;
  position: fixed;
  animation: ${fadeToBlack} 0.3s ease-in-out;
  overflow: scroll;
`;
